module.exports = require('umi-plugin-locale');
